import { stopWords } from "./stopwords";

export const constants = {
    monthNames : ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December" ],
    accessLevels : {
        0: 'Internal',
        1: 'Confidential',
        2: 'Restricted'
    },
    recordsPerPage : {
        signals : 12,
        vulns: 12,
        activity: 6,            // portal dashboard
        activitydashboard: 12,  // activity dashboard
        cases: 12,
    },
    ignoreList : stopWords,    
    graphColors : [   
        '#1961ac',
        '#4bb4e6',
        '#bcdff7',
        '#007836',
        '#50be87',
        '#bbdecf',
        '#f193bd',
        '#ffb4e6',
        '#fce5f1',
        '#482683',
        '#a885d8',
        '#d6c1df',
        '#f9b000',
        '#fff8bd',
        '#ffd200',
        '#595959',
        '#dadada',
        '#8f8f8f'
    ],
    graphSixColors : [   
        '#1961ac',
        '#4bb4e6',
        '#bcdff7',
        '#007836',
        '#50be87',
        '#bbdecf'
    ],
    graphContrastingColors : [   
        '#4bb4e6',
        '#50be87',
        '#ffb4e6',
        '#a885d8',
        '#ffd200',
        '#8f8f8f'
    ],
    local : {
        userPreferences: "userPreferences",
        userPreferenceLanguage: "language",
        userPreferenceRegion: "region",
        flags: {
            signals : "signal",
            vulns: "vulns",
            support: "support",
            assets: "asset"
        },
        views: {
            vuln: "vulnViewType",
            signals: "signalViewType",
            support: "supportViewType",
            asset: "assetViewType"
        },
        watch : {
            vuln: "products"
        }
    },
    fields : {
        signals : {
            category : "mainCategory",
            urgency: "signalUrgency",
            publishDate: "publishDate",
            lastUpdateDate: "date"
        },
        vulns : {
            severity : "impact.baseMetricV3.cvssV3.baseSeverity"
        }
    },
    activity : {
        types : {
            signal: {
                type: "Signals",
                title: "Signals from World Watch",
                lastLoginUrl: "/updates/worldwatch/dashboard/lastlogin",
                viewUrl: "/updates/worldwatch/viewSignal/"
            },
            vuln: {
                type: "Vulnerabilities",
                title: "Vulnerabilities from NVD database",
                lastLoginUrl: "/updates/vulnerabilities/dashboard/lastlogin",
                lastDays: "/updates/vulnerabilities/dashboard/7days",
                viewUrl: "/updates/vulnerabilities/viewVuln/"
            },
            support : {
                updated : {
                    type: "Case",
                    title: "Cases updated",
                    lastLoginUrl: "/support/dashboard/lastloginupdated",
                    viewUrl: "/support/view/"
                },
                created : {
                    type: "Case",
                    title: "New cases created",
                    lastLoginUrl: "/support/dashboard/lastlogincreated",
                    viewUrl: "/support/view/"
                }
            }
        }
    },
    itsm: {
        open: "Open",
        high: "High",
        critical: "Critical",
        pendingCustomer: "Pending (Customer)"
    },
    mileStoneReferences: {
        firstresponse: '557b0000000GmknAAC',
        resolution: '5570X0000004FbrQAE'
    },
    incidentStatus: {
        truepositive: ['Closed', 'Resolved', 'True Positive'],
        falsepositive: ['Resolved – False positive', 'False Positive']
    },
    statusGroups: {
        "Pending (Orange Cyberdefense)" : ['New', 'Open', 'Pending (Contact)', 'Pending (External)', 'Work in progress'],
        "Pending (Customer)": ['Pending (Customer)', 'Pending Auto-close'],
        "Pending (Due Date)": ['Pending (Due Date)', 'Scheduled', 'Pending (Monitoring)']
    }
}